import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangelogConfig, ChangelogItem } from './changelog.model';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionComponent, AccordionPanelComponent } from 'ngx-bootstrap/accordion';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'pace-changelog',
    imports: [CommonModule, TranslateModule, AccordionComponent, AccordionPanelComponent, FontAwesomeModule],
    templateUrl: './pace-changelog.component.html',
    styleUrl: './pace-changelog.component.scss',
    standalone: true,
})
export class PaceChangelogComponent {
    public changelogConfig = input.required<ChangelogConfig>();
    public changelogs = input.required<ChangelogItem[]>();

    public readonly iconDown = faChevronDown;
    public readonly iconRight = faChevronRight;

    public typeHeadline(key: string): string {
        const headlineTranslations = this.changelogConfig().headlines;

        if (headlineTranslations && headlineTranslations[key]) {
            return headlineTranslations[key];
        }
        return key;
    }
}
